export default __webpack_public_path__ + "static/media/imageforup.bc635dc2.jfif";